import airportTypeOptions from "../config/airportTypes.json";
import { protectedAirports } from "../fallbackAirports";

const typeOrder = new Map(
  airportTypeOptions.map(function (option, index) {
    return [option.value, index];
  })
);

export const supportedAirportTypes = airportTypeOptions.map(function (option) {
  return option.value;
});

export const defaultEnabledAirportTypes = airportTypeOptions
  .filter(function (option) {
    return option.defaultEnabled;
  })
  .map(function (option) {
    return option.value;
  });

export const airportTypeLabels = airportTypeOptions.reduce(function (labels, option) {
  labels[option.value] = option.label;
  return labels;
}, {});

export function airportMarkerRadius(type) {
  const option = airportTypeOptions.find(function (item) {
    return item.value === type;
  });
  return option ? option.markerRadius : 3;
}

export function mergeAirports(list) {
  const map = new Map();
  [...protectedAirports, ...list].forEach(function (airport) {
    const key = airport.iata || airport.icao || airport.id;
    if (!key) return;
    map.set(key, airport);
  });
  protectedAirports.forEach(function (airport) {
    const key = airport.iata || airport.icao || airport.id;
    map.set(key, airport);
  });
  return Array.from(map.values()).sort(function (a, b) {
    const orderA = typeOrder.has(a.type) ? typeOrder.get(a.type) : 999;
    const orderB = typeOrder.has(b.type) ? typeOrder.get(b.type) : 999;
    if (orderA !== orderB) return orderA - orderB;
    return a.name.localeCompare(b.name);
  });
}

export function parseAirports(rows, allowedTypes) {
  const types = Array.isArray(allowedTypes) && allowedTypes.length ? allowedTypes : supportedAirportTypes;
  const allowed = new Set(types);
  const parsed = rows
    .filter(function (airport) {
      return allowed.has(airport.type) && airport.latitude_deg && airport.longitude_deg;
    })
    .map(function (airport) {
      return {
        id: String(airport.id || airport.ident),
        name: airport.name || "Unknown airport",
        iata: airport.iata_code || "",
        icao: airport.ident || "",
        type: airport.type,
        lat: parseFloat(airport.latitude_deg),
        lon: parseFloat(airport.longitude_deg),
        country: airport.iso_country || ""
      };
    })
    .filter(function (airport) {
      return Number.isFinite(airport.lat) && Number.isFinite(airport.lon);
    });

  return mergeAirports(parsed);
}
